import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

// export const getUserAddress = async () => {
//     const { token, userID } = useCurrentUser();
//     const apiURL = `${API_HOST}/addresses/user_address`;

//     try {
//         const response = await axios.get(apiURL, {
//             headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${token}`,
//                 'x-dqpn-user-id': userID,
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error getting user address:', error);
//         throw error;
//     }
// }

export const getUserAddress = async () => {
  const { token, userID } = useCurrentUser();
  const apiURL = `${API_HOST}/orders/location`;

  if (!token || !userID) {
    return null;
  }

  try {
    const response = await axios.get(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error getting user address:', error);
    throw error;
  }
};
